export enum SubscriptionState {
  notFound = 'not_found',
  active = 'active',
  canceled = 'canceled',
  expired = 'expired',
  expiring = 'expiring',
  paused = 'paused',
}
